<template>
  <div class="mx-8 pb-9">
    <div>
      <v-autocomplete
        placeholder="Add to Existing Manual"
        :items="GetDigitalManuals"
        item-text="Title"
        item-value="Id"
        v-model="uploadNewManualForm.existingManual"
        :error-messages="
          $v.uploadNewManualForm.existingManual.$error
            ? 'This field is required'
            : null
        "
      />

      <v-select
        :items="language"
        placeholder="Language"
        hide-details=""
        v-model="uploadNewManualForm.Language"
      ></v-select>
      <div
        class="error--text mt-3"
        v-if="$v.uploadNewManualForm.Language.$error"
      >
        Select Language
      </div>
    </div>
    <h5 class="mt-5">File</h5>
    <div class="d-flex align-center">
      <v-btn
        class="text_style mb-4 px-11"
        color="primary"
        outlined
        @click="onButtonClick"
        >Upload Manual</v-btn
      >
      <input
        ref="uploader"
        class="d-none"
        type="file"
        @change="onFileChanged"
      />
      <div class="d-flex align-center ml-4" style="height: 100%">
        <v-chip
          v-if="uploadNewManualForm.UploadedManualFile"
          color="primary"
          @click:close="uploadNewManualForm.UploadedManualFile = ''"
          class="mt-n4"
          close
          outlined
          pill
          >{{ uploadNewManualForm.UploadedManualFile }}</v-chip
        >
      </div>
    </div>
    <div
      class="error--text pb-3"
      v-if="$v.uploadNewManualForm.UploadedManualFile.$error"
    >
      Please add file
    </div>
    <div class="d-flex align-center">
      <v-btn
        class="text_style mb-4 px-8"
        color="primary"
        outlined
        @click="onButtonClickThumbnail"
        >Upload Thumbnail</v-btn
      >
      <input
        ref="uploader1"
        class="d-none"
        type="file"
        accept="image/*"
        @change="onFileChangedThumbnail"
      />
      <div class="d-flex align-center ml-4" style="height: 100%">
        <v-chip
          v-if="uploadNewManualForm.UploadedThumbnail"
          color="primary"
          @click:close="uploadNewManualForm.UploadedThumbnail = ''"
          class="mt-n4"
          close
          outlined
          pill
          >{{ uploadNewManualForm.UploadedThumbnail }}</v-chip
        >
        <p
          style="color: #8080808f"
          v-if="!uploadNewManualForm.UploadedThumbnail"
        >
          (300 x 400 px)
        </p>
      </div>
    </div>
    <div
      class="error--text pb-3"
      v-if="$v.uploadNewManualForm.UploadedThumbnail.$error"
    >
      Please add image
    </div>
    <!-- <div
      class="error--text"
      v-if="$v.uploadNewManualForm.UploadedThumbnail.$error"
    >
      Please enter thumbnail
    </div> -->
    <div class="d-flex justify-end mx-5">
      <v-btn
        class="px-14 py-6 text_style"
        color="#A1A3A8"
        text
        @click="close(true)"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="btnloader"
        color="primary"
        class="px-14 py-6 text_style"
        @click="send()"
      >
        <span class="pa-4 text_style" v-if="!btnloader"> Save </span>
        <v-progress-circular
          v-else
          indeterminate
          size="20"
          class="px-5"
          color="white"
        />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  name: "UploadManualComponent",
  computed: {
    ...mapGetters(["GetLoggedInUser", "GetDigitalManuals"]),
  },
  props: ["EditSubManual"],
  data() {
    return {
      btnloader: false,
      fileChanged: false,
      thumbnailChanged: false,
      isSelecting: false,
      language: [
        "English",
        "French",
        "German",
        "Japanese",
        "Czech",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],

      uploadNewManualForm: {
        existingManual: null,
        Language: "English",
        UploadedManualFile: "",
        UploadedThumbnail: "",
        Thumbnail: null,
        ManualFile: null,
      },
    };
  },
  validations: {
    uploadNewManualForm: {
      existingManual: { required },
      Language: { required },
      UploadedManualFile: { required },
    UploadedThumbnail: { required },
    },
  },
  mounted() {
    console.log("EditSubManual ",this.EditSubManual)
   if(this.EditSubManual){
    const manualFileName = this.EditSubManual.File.substring(0, 32);
    const thumbnail = this.EditSubManual.ThumbnailImage.substring(0, 32)
    this.uploadNewManualForm.UploadedManualFile = manualFileName;
    this.uploadNewManualForm.UploadedThumbnail = thumbnail;
    this.uploadNewManualForm.Language = this.EditSubManual.Language;
    this.uploadNewManualForm.existingManual =
      this.EditSubManual.DigitalManualId;
   }
  },
  methods: {
    close(cancel) {
      this.$emit("close", cancel);
    },

    send() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      } else {
        this.btnloader = true;
        const form = new FormData();
        form.append("Id", this.EditSubManual.Id);
        form.append("UserId", this.GetLoggedInUser.Id);
        form.append("DigitalManualId", this.uploadNewManualForm.existingManual);
        form.append("Language", this.uploadNewManualForm.Language);
        if (this.thumbnailChanged) {
          form.append("Thumbnail", this.uploadNewManualForm.Thumbnail);
        }
        if (this.fileChanged) {
          form.append("File", this.uploadNewManualForm.ManualFile);
        }

        this.$store.dispatch("UpdateDigitalManualFile", form).then((res) => {
          this.btnloader = false;
          if (res.Status) {
            this.close();
            this.$swal
              .fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Manual edited successfully",
                showConfirmButton: false,
                timer: 1500,
              })
              .catch(() => {
                this.btnloader = false;
              });
          }
        });
      }
    },

    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.fileChanged = true;
      this.uploadNewManualForm.ManualFile = e.target.files[0];
      this.uploadNewManualForm.UploadedManualFile =
        this.uploadNewManualForm.ManualFile.name.substring(0, 32);
      this.$refs.uploader.value = null;
    },
    onButtonClickThumbnail() {
      this.$refs.uploader1.click();
    },
    onFileChangedThumbnail(e) {
      this.thumbnailChanged = true;
      this.uploadNewManualForm.Thumbnail = e.target.files[0];
      this.uploadNewManualForm.UploadedThumbnail =
        this.uploadNewManualForm.Thumbnail.name.substring(0, 32);
      this.$refs.uploader1.value = null;
    },
  },
};
</script>
